import { SxProps, Theme } from '@mui/material';

export const styles: Record<string, SxProps<Theme>> = {
  containerHeader: {
    margin: 0,
    position: 'relative',
    py: '20px',
    px: { xs: '30px', sm: '60px', md: '110px' },
    backgroundColor: 'var(--main-bg-color)',
    color: 'var(--main-text-color)',
    alignItems: 'center',
  },
  imgLogo: (theme: Theme) => ({
    width: '65px',
    cursor: 'initial',
    [theme.breakpoints.down('md')]: {
      width: '55px',
    },
    [theme.breakpoints.down('sm')]: {
      width: '55px',
    },
  }),
  title: (theme: Theme) => ({
    fontSize: '16px',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  }),
  containerFooter: {
    margin: 0,
    position: 'relative',
    py: '20px',
    px: { xs: '30px', sm: '60px', md: '110px' },
    backgroundColor: 'var(--main-bg-color)',
    // color: 'var(--main-text-color)',
    alignItems: 'center',
    display: 'flex',
  },

  titleH: (theme: Theme) => ({
    fontSize: '16px',
    textAlign: 'start',
    color: 'var(--second-text-color)',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  }),
  titleP: (theme: Theme) => ({
    fontSize: '14px',
    textAlign: 'start',
    color: 'var(--second-text-color)',
    [theme.breakpoints.down('md')]: {
      fontSize: '12px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '10px',
    },
  }),
  titleNumber: (theme: Theme) => ({
    fontSize: '16px',
    textAlign: 'center',
    color: 'var(--second-text-color)',
    [theme.breakpoints.down('md')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
  }),
  gridContainer: { alignItems: 'center', justifyContent: 'space-between', wrap: 'nowrap' },
};
